
import React from 'react';
import { LucideIcon } from 'lucide-react';
import { Button } from './ui/Button';

interface EmptyStateProps {
  icon: LucideIcon;
  title?: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
    icon?: LucideIcon;
  };
}

export const EmptyState: React.FC<EmptyStateProps> = ({ 
  icon: Icon, 
  title = "Zatim zadna data", 
  description = "V teto sekci zatim nejsou zadne zaznamy nebo nejsou dostupne zadne informace.",
  action 
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-6 text-center bg-white dark:bg-slate-800 rounded-ds-card shadow-ds-card w-full animate-fade-in">
      <div className="w-14 h-14 bg-slate-100 dark:bg-slate-700 rounded-ds-card flex items-center justify-center mb-4 text-slate-400 dark:text-slate-500">
        <Icon size={28} strokeWidth={1.5} />
      </div>
      <h3 className="text-ds-h3 text-slate-900 dark:text-white mb-2">{title}</h3>
      <p className="text-ds-body text-slate-500 dark:text-slate-400 max-w-sm mb-6">
        {description}
      </p>
      {action && (
        <Button 
          onClick={action.onClick}
          icon={action.icon && <action.icon size={18} />}
        >
          {action.label}
        </Button>
      )}
    </div>
  );
};
